module.exports = __webpack_public_path__ + "static/java-098db3790b37a0a7e845c178f6ba983d.svg";